export interface Review {
  name: string;
  text: string;
  datetime: string; // YYYY-MM-DD HH:MI:SS
  rating: number; // 1-5
  helpful_count?: number;
  not_helpful_count?: number;
}

export type Reviews = Review[]; 